import { create } from 'zustand';
import type {
  Project,
  Session,
  SessionAccessInfo as SharedSessionAccessInfo,
} from '@claude-code-api/shared';

export type SessionAccessInfo = SharedSessionAccessInfo;

type SessionConfirmAction = 'stop' | 'restart' | 'delete' | null;

interface SessionPageStore {
  session: Session | null;
  project: Project | null;
  accessInfo: SessionAccessInfo | null;
  loading: boolean;
  showPassword: boolean;
  copiedField: string | null;
  actionLoading: string | null;
  confirmAction: SessionConfirmAction;
  showAdvanced: boolean;
  setSession: (value: Session | null) => void;
  setProject: (value: Project | null) => void;
  setAccessInfo: (value: SessionAccessInfo | null) => void;
  setLoading: (value: boolean) => void;
  setShowPassword: (value: boolean) => void;
  setCopiedField: (value: string | null) => void;
  setActionLoading: (value: string | null) => void;
  setConfirmAction: (value: SessionConfirmAction) => void;
  setShowAdvanced: (value: boolean) => void;
  resetForSession: () => void;
}

const initialState = {
  session: null,
  project: null,
  accessInfo: null,
  loading: true,
  showPassword: false,
  copiedField: null,
  actionLoading: null,
  confirmAction: null,
  showAdvanced: false,
};

export const useSessionPageStore = create<SessionPageStore>((set) => ({
  ...initialState,
  setSession: (value) => set({ session: value }),
  setProject: (value) => set({ project: value }),
  setAccessInfo: (value) => set({ accessInfo: value }),
  setLoading: (value) => set({ loading: value }),
  setShowPassword: (value) => set({ showPassword: value }),
  setCopiedField: (value) => set({ copiedField: value }),
  setActionLoading: (value) => set({ actionLoading: value }),
  setConfirmAction: (value) => set({ confirmAction: value }),
  setShowAdvanced: (value) => set({ showAdvanced: value }),
  resetForSession: () => set({ ...initialState }),
}));
